import React from "react";
import { View, Icon } from "ui";
import { alertMutations } from "api";
import moment, { Moment } from "moment";
import DatePicker from "react-datepicker";
import { SERVER_DATE_FORMAT, SERVER_TIME_FORMAT } from "../shared/constants";
import { User } from "types";
import { notify } from "shared/services";
import { withRouter, RouteComponentProps } from "react-router";

interface P {
  memo_id: string;
  alert_template_id: string;
  user: User;
}
interface S {
  open: boolean;
}

class MemoAlertSimpleCreate extends React.Component<
  P & RouteComponentProps,
  S
> {
  public state = {
    open: false
  };
  public handleChange = (date: Moment) => {};
  public handleOpen = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    e.preventDefault();
    e.nativeEvent.stopImmediatePropagation();
    this.setState({ open: true });
  }
  public handleClose = () => {
    this.setState({ open: false });
  }

  public render() {
    const minDate = moment().add(15, "d");

    return (
      <React.Fragment>
        <View
          style={{ height: "100%", width: "100%" }}
          flexDirection="row"
          alignItems="center"
          justifyContent="center"
          onClick={this.handleOpen}
        >
          <Icon name="calendar" color="white" size={2} />
        </View>
        <alertMutations.UpsertAlert>
          {upsert =>
            this.state.open && (
              <DatePicker
                onChange={async (date, e) => {
                  const {
                    memo_id,
                    alert_template_id,
                    user,
                    history
                  } = this.props;
                  e.preventDefault();
                  e.stopPropagation();
                  e.nativeEvent.stopImmediatePropagation();
                  this.setState({ open: false }, async () => {
                    if (!this.props.user.subscribed) {
                      notify(
                        "Ai nevoie de un abonament activ pentru a creea alerte"
                      );
                      this.props.history.push("/app/abonament");
                      return;
                    }
                    const res = await upsert({
                      variables: {
                        memo_id,
                        alert_template_id,
                        first_alert_time: moment("10:00", "HH:mm").format(
                          SERVER_TIME_FORMAT
                        ),
                        second_alert_time: moment("14:00", "HH:mm").format(
                          SERVER_TIME_FORMAT
                        ),
                        start_date: date
                          .clone()
                          .subtract(14, "d")
                          .utc(true)
                          .format(SERVER_DATE_FORMAT),
                        end_date: date.utc(true).format(SERVER_DATE_FORMAT),
                        phones: [user.primary_phone_id],
                        emails: [user.primary_email_id]
                      }
                    });
                    if (!res || !res.data || !res.data.upsertAlert) {
                      return;
                    }

                    notify("Alerta a fost creata");
                    history.push(
                      `/app/memos/${memo_id}/alert/${res.data.upsertAlert.id}`
                    );
                    window.scroll({ top: 0, behavior: "smooth" });
                  });
                }}
                withPortal
                inline
                locale="ro"
                timeIntervals={15}
                onClickOutside={this.handleClose}
                timeCaption=""
                // maxDate={maxDate}
                minDate={minDate}
              />
            )
          }
        </alertMutations.UpsertAlert>
      </React.Fragment>
    );
  }
}
export default withRouter(MemoAlertSimpleCreate);



// WEBPACK FOOTER //
// ./src/components/MemoAlertSimpleCreate.tsx